import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DirectoryPage, type DirectoryParams } from '@/features/profiles/directory-page';

const searchSchema = z.object({
  q: z.string().optional().catch(undefined),
  kind: z.string().optional().catch(undefined),
  speciality: z.string().optional().catch(undefined),
  county: z.string().optional().catch(undefined),
  min_rating: z.coerce.number().optional().catch(undefined),
  nca_category: z.string().optional().catch(undefined),
  verified: z.coerce.boolean().optional().catch(undefined),
  sort: z.enum(['rating', 'name', 'recent']).optional().catch(undefined),
  page: z.coerce.number().int().positive().optional().catch(undefined),
});

/** Module 10: published company profiles, searched and paged on the server. */
export const Route = createFileRoute('/_app/directory')({
  validateSearch: searchSchema,
  component: DirectoryRoute,
});

function DirectoryRoute() {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DirectoryPage
      params={params}
      onChange={(next: DirectoryParams) => void navigate({ search: next, replace: true })}
    />
  );
}
